import { useState } from 'react';
import { addItems, deleteItem, deleteItems, editItem, editItems } from 'utils/lists';

const useTableData = <T extends Record<string, any>>(initialItems: T[] = []) => {
  const [tableData, setTableData] = useState<T[]>(initialItems);

  const handleBulkDelete = async (ids: string[], property = '_id') => {
    setTableData((prevTableData) => deleteItems<T>(prevTableData, ids, property));
  };

  const handleAdd = (items: T[], start = true) =>
    setTableData((prevTableData) => addItems(prevTableData, items, start));

  const handleEdit = (index: number, newItem: T) => {
    setTableData((prevTableData) => editItem<T>(prevTableData, index, newItem));
  };

  const handleBulkEdit = (ids: string[], data: Partial<T>, property = '_id') => {
    setTableData((prevTableData) => editItems(prevTableData, ids, data, property));
  };

  const handleDelete = (id: string, property = '_id') => {
    setTableData((prevTableData) => deleteItem(prevTableData, id, property));
  };

  return [
    tableData,
    setTableData,
    {
      bulkDeleteItems: handleBulkDelete,
      deleteItem: handleDelete,
      addItems: handleAdd,
      editItem: handleEdit,
      editItems: handleBulkEdit,
    },
  ] as const;
};

export default useTableData;
